<template>
  <div>
    <Header/>
    <el-container>
      <Left/>
      <div class="instruments">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-row>
            <el-col :span="2">
              <div class="seize"></div>
            </el-col>
            <el-col :span="22">
              <el-form-item label="故障仪器" prop="deviceId">
                <el-select
                  v-model="form.deviceId"
                  placeholder="请选择仪器"
                  style="width:300px"
                  @change="chooseDevice(form.deviceId, deviceList)"
                >
                  <el-option
                    :label="i.device"
                    :value="i.deviceId"
                    v-for="(i,index) in deviceList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <div class="seize"></div>
            </el-col>
            <el-col :span="22">
              <el-form-item label="问题描述" prop="suggestion">
                <el-input
                  type="textarea"
                  v-model="form.suggestion"
                  style="width:455px;height:115px;"
                  placeholder="请输入问题描述，200个汉字长度以内"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <div class="seize"></div>
            </el-col>
            <el-col :span="22">
              <el-form-item label="报修人" prop="myname">
                <el-select
                  v-model="form.myname"
                  placeholder="请选择报修人"
                  style="width:135px"
                  @change="chooseStaff(form.myname,staffList)"
                >
                  <el-option
                    :label="i.staffName"
                    :value="i.staffId"
                    v-for="(i,index) in staffList"
                    :key="index"
                  ></el-option>
                </el-select>
                <span class="contacts">联系方式 {{form.phone}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <div class="seize"></div>
            </el-col>
            <el-col :span="22">
              <el-form-item label="附件上传">
                <el-upload
                  class="uploadLists"
                  ref="upload"
                  :action="uploadUrl"
                  list-type="picture-card"
                  :file-list="fileListData"
                  multiple
                  :limit="3"
                  :beforeUpload="beforeAvatarUpload"
                  :before-remove="beforeRemove"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :onError="uploadError"
                  :onSuccess="uploadSuccess"
                  :on-change="addFile"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="fileImg" alt>
                </el-dialog>
                <div class="picNum">
                  <b>{{fileLength}}</b>/3
                </div>
                <div class="require">
                  <b>附件要求：</b>
                  <p>1.文件大小2M以内。</p>
                  <p>2.最多上传3个文件。</p>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              <div class="seize"></div>
            </el-col>
            <el-col :span="22">
              <div class="btnOptions">
                <el-button class="darkBtn" @click="resetData">取消</el-button>
                <el-button class="redBtn" @click="onSubmit" :disabled="!clickSwitch">提交</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row class="borTop">
            <div class="topTab">报修记录</div>
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              :header-cell-style="{background:'#EFF1F5'}"
            >
              <el-table-column align="center" type="index" label="序号" width="60"></el-table-column>
              <el-table-column align="center" prop="device" label="故障仪器" width="130">
                <template slot-scope="scope">{{scope.row.device | filterRow}}</template>
              </el-table-column>
              <el-table-column align="center" prop="suggestion" label="问题描述"></el-table-column>
              <el-table-column align="center" prop="name" label="报修人"></el-table-column>
              <el-table-column align="center" prop="phone" label="手机号" width="120"></el-table-column>
              <el-table-column align="center" prop="createTime" label="报修时间" width="180">
                <template slot-scope="scope">{{scope.row.createTime | formatDateLiness | filterRow}}</template>
              </el-table-column>
              <el-table-column align="center" prop="flag" label="状态" width="80">
                <template slot-scope="scope">{{scope.row.flag | filterFlag}}</template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-form>

        <el-pagination
          v-show="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px;"
        ></el-pagination>
      </div>
    </el-container>
  </div>
</template>
<script type="text/javascript">
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import Left from "@/components/common/Left.vue";
import {
  addDeviceFix,
  fixLists,
  allStaff,
  uploadUrl,
  deleteFiles
} from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components: {
    Header,
    Left,
    Footer
  },
  data() {
    //限制200字以内
    const isvalidateLimit = (rule, value, callback) => {
      if (value && value.length > 200) {
        callback(new Error("最多 200 个汉字长度"));
      } else {
        callback();
      }
    };
    return {
      form: {
        device: "",
        deviceId: "",
        suggestion: "",
        myname: "",
        phone: "",
        files: []
      },
      staffList: [],
      uploadUrl,
      fileListData: [],
      fileLength: 0,
      dialogVisible: false,
      fileImg: "",
      tableData: [],
      rules: {
        deviceId: [
          { required: true, message: "请选择故障仪器", trigger: "change" }
        ],
        suggestion: [
          { required: true, message: "请输入问题描述", trigger: "blur" },
          { validator: isvalidateLimit, trigger: "blur" }
        ],
        myname: [{ required: true, message: "请选择报修人", trigger: "change" }]
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
      deviceList: [
        { device: "摩力21专用360°体雕仪", deviceId: "MCH020100010" },
        { device: "产道动力修复仪", deviceId: "MCH020100003" }
      ],
      clickSwitch: true
    };
  },
  created() {
    this.detailInfo();
  },
  activated() {
    this.form = this.$options.data().form;
    this.$refs.form.resetFields();
    this.detailInfo();
  },
  methods: {
    detailInfo() {
      // 所有员工
      allStaff({
        status: "1",
        staffType: "1",
        deleteFlag: "0"
      }).then(res => {
        this.staffList = res.data;
      });

      // 报修记录
      fixLists({
        pageSize: this.pageSize,
        pageNumber: this.currentPage
      }).then(res => {
        if (res.code == 1) {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        }
      });
      this.form.myname = this.$store.state.userInfo.staffId;
      this.form.phone = this.$store.state.userInfo.staffPhone;
    },
    chooseDevice(val, list) {
      // 选择报修仪器
      for (let i of list) {
        if (i.deviceId == val) {
          this.form.device = i.device;
        }
      }
    },
    chooseStaff(id, list) {
      for (let i of list) {
        if (i.staffId == id) {
          this.form.phone = i.staffPhone;
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.detailInfo();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.detailInfo();
    },
    handleRemove(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        return;
      } else {
        //   删除图片
        this.form.files.forEach((i, index) => {
          if (i.file == file.response.files[0].url) {
            this.form.files.splice(index, 1);
          }
        });
        this.fileLength = fileList.length;
      }
    },
    handlePictureCardPreview(file) {
      let curName = file.name.split(".");
      const extension = curName[curName.length - 1] === "jpg";
      const extension1 = curName[curName.length - 1] === "png";
      const extension2 = curName[curName.length - 1] === "jpeg";
      const extension3 = curName[curName.length - 1] === "gif";
      if (extension || extension1 || extension2 || extension3) {
        this.fileImg = file.url;
        this.dialogVisible = true;
      } else {
        // 文件时下载
        window.open(file.url);
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        return;
      } else {
        if (file) {
          return this.$confirm(`确定移除 ${file.name}？`);
        } else {
          let imgNames = file.response.data.images[0].imgUrl
            .split("image")[1]
            .substr(1);
          return this.$confirm(`确定移除 ${imgNames}？`);
        }
      }
    },
    uploadSuccess(response, file, fileList) {
      // 上传成功后的回调
      //   this.fileUrl.push(response.obj[0]);
      this.form.files.push({
        file: response.files[0].url,
        fileName: response.files[0].name
      });
    },
    uploadError(response, file, fileList) {
      // 上传错误
      this.$message({
        message: "上传失败，请重试！",
        type: "error"
      });
    },
    addFile(file, fileList) {
      setTimeout(() => {
        $(".el-upload-list--picture-card .el-upload-list__item").each(
          (index, item) => {
            const curText = $(item)
              .children("a")
              .text();
            const curTypes = curText.split(".")[curText.split(".").length - 1];
            if (
              curTypes.indexOf("jpg") != -1 ||
              curTypes.indexOf("png") != -1 ||
              curTypes.indexOf("jpeg") != -1 ||
              curTypes.indexOf("gif") != -1
            ) {
              $(item)
                .children("a")
                .css("display", "none");
            } else {
              $(item)
                .children("a")
                .css("display", "block");
            }
          }
        );
      });
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        return;
      } else {
        this.fileLength = fileList.length;
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 2M!");
      }
      return isLt2M;
    },
    onSubmit() {
      // 提交
      this.clickSwitch = false;
      this.$refs.form.validate(valid => {
        if (valid) {
          for (let i of this.staffList) {
            if (i.staffId == this.form.myname) {
              this.form.name = i.staffName;
            }
          }
          addDeviceFix(this.form).then(res => {
            if (res.code == 1) {
              this.$refs.form.resetFields();
              this.fileListData = [];
              this.fileLength = 0;
              this.detailInfo();
            }
            this.clickSwitch = true;
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        } else {
          this.clickSwitch = true;
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetData() {
      // 取消
      this.$confirm(
        "确定要取消本次仪器报修吗？取消后本次编辑的内容不保存",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$refs.form.resetFields();
          this.fileListData = [];
          this.fileLength = 0;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
.instruments {
  width: 950px;
  overflow: hidden;
  margin: 0 auto;
  padding: 80px 0 60px;
  position: relative;
  .topTab {
    width: 95px;
    height: 38px;
    line-height: 38px;
    background: #3b404f;
    border-radius: 15px 15px 0px 0px;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
  }
  .uploadLists {
    display: inline-block;
  }
  .picNum {
    width: 72px;
    height: 28px;
    border: 1px solid #dee6ea;
    border-radius: 14px;
    margin: 15px 0 20px;
    text-align: center;
    line-height: 28px;
  }
  .require {
    line-height: 27px;
    color: #666;
  }
  .contacts {
    color: #444;
    margin-left: 50px;
  }
  .seize {
    height: 20px;
  }
  .borTop {
    border-top: 1px dashed #c0c5cf;
    padding-top: 25px;
    margin-top: 25px;
  }
  .el-pagination {
    text-align: right;
  }
}
</style>
<style lang="less">
.btnOptions {
  margin: 0 0 20px 100px;
  .el-button {
    width: 135px;
    height: 46px;
  }
}
.instruments {
  .uploadLists {
    .el-upload-list--picture-card .el-upload-list__item-name {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 116px;
      white-space: normal;
      line-height: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/instrument/instrument.vue